var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/usertype-history-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-37ffa213!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/usertype-history-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/UsertypeHistoryEdit.vue
// module id = 738
// module chunks = 1